<template>
  <div class="mf-card chart-container">
    <span v-if="!isPdf" class="pa-1 table-card-title">Gênero</span>
    <mf-loading :loader="['last-update', 'primeiro-registro', 'genero']" :width="4" :height="70" loader-type="table">
      <v-container v-if="infoGenero.length" fluid class="pa-0" fill-height>
        <v-layout align-start wrap>
          <v-flex xs12 md6>
            <data-card :infoGenero="infoGenero" :isPdf="isPdf" />
          </v-flex>
          <v-flex xs12 md6>
            <chart :array="infoGenero" label-property-name="DES_SEXO_CLIENTE" data-property-name="PORCENTAGEM" />
          </v-flex>
        </v-layout>
      </v-container>
      <v-container v-else class="my-6">
        <v-row align="center">
          <v-col align="center">
            <span class="subtitle">Nenhum resultado encontrado</span>
          </v-col>
        </v-row>
      </v-container>
    </mf-loading>
  </div>
</template>

<script>
import DataCard from '@/modules/clientes/perfil-demografico/views/pages/GeneroDataTable.vue'
import Chart from '@/modules/clientes/perfil-demografico/views/pages/PerfilDemograficoChart.vue'
import { mapState } from 'vuex'

export default {
  components: {
    DataCard,
    Chart,
  },
  props: {
    isPdf: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      stateInfoGenero: (state) => state.clientes.perfilDemograficoGenero,
      stateFilters: (state) => state.filters,
    }),
    infoGenero() {
      const totalCadastros = this.stateInfoGenero.reduce((total, current) => total + current['NUM_CLIENTES_CADASTRADOS'], 0)
      return this.stateInfoGenero.map((object) => {
        if (object['DES_SEXO_CLIENTE'] === '') {
          object['DES_SEXO_CLIENTE'] = 'Outros ou Indefinido'
          object.gender = 'U'
        } else if (object['DES_SEXO_CLIENTE'] === 'M') {
          object['DES_SEXO_CLIENTE'] = 'Masculino'
          object.gender = 'M'
        } else if (object['DES_SEXO_CLIENTE'] === 'F') {
          object['DES_SEXO_CLIENTE'] = 'Feminino'
          object.gender = 'F'
        }
        object['PORCENTAGEM'] = (object['NUM_CLIENTES_CADASTRADOS'] / totalCadastros) * 100
        return object
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-container {
  display: flex;
  flex-direction: column;
  padding: 16px;
  margin: 16px 0;
}
</style>
